<script type="text/javascript">
// 定义一些公共的属性和方法

//webSocket地址
// const wapSocketUrl = "ws://localhost:8668/wapSocket";

// //webSocket地址
const wapSocketUrl = "ws://wap.ptty.com.cn/wapSocket";

// 暴露出这些属性
export default {
  wapSocketUrl
};
</script>



// WEBPACK FOOTER //
// src/allParam/allParam.vue